var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTextLinkArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "11px",
    viewBox: "0 0 12 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website",
    stroke: "none",
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Blog",
    transform: "translate(-1138.000000, -39.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "icon-text-link-arrow",
    points: "1144.5125 39 1143.089 40.414 1146.177 43.502 1138 43.502 1138 45.498 1146.177 45.498 1143.089 48.586 1144.5125 50 1150 44.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTextLinkArrow);
export default __webpack_public_path__ + "static/media/icon-text-link-arrow.065dd281fc136b9d59222e3dba1e0b3f.svg";
export { ForwardRef as ReactComponent };